import React from 'react';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import config from './config';
import Benefits from './pages/Benefits';
import Education from './pages/Education';
import Layout from '../../components/Layout';

const path = config.PATH;
const name = config.NAME;

const routes = [
  {
    name,
    path,
    component: Layout,
    icon: <CardGiftcardIcon />,
    routes: [
      {
        name: 'Descuentos', path: `${path}/beneficios`, component: Benefits, exact: true,
      },
      {
        name: 'Educación', path: `${path}/educacion`, component: Education, exact: true,
      },
    ],
  },
];

export default routes;
